export function executeRecaptcha(siteKey = "6LcrkwwrAAAAAEG6VXS-BgaVPRAEmFzLPn1RpRHu", action = "submit") {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        return reject(new Error("reCAPTCHA is not loaded"));
      }
  
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  }